let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("j2xC0")).then(() => parcelRequire('jT2TW'));